// Utilities
import MessagingTopic from "./messaging-topic";
// Shared Variables
let globalTopic = new MessagingTopic();

//#region Private Methods

//#endregion

/**
 * @class GlobalTopic
 * @description Helper used for managing reusable components.
 * @author Kelvin John Santos
 * @version 1.0
 * @since January 7, 2019
 */
export default class GlobalTopic {
  /**
   * @function publishChange
   * @description Method to publish message globally.
   * @param {Object} msg message to be published.
   */
  static publishChange(msg) {
    globalTopic.publish(msg);
  }

  /**
   * @function addListener
   * @description Method to publish message globally.
   * @param {Function} strategy subscriber strategy.
   */
  static addListener(strategy) {
    globalTopic.subscribe(strategy);
  }

  static clearListener() {
    globalTopic.unsubscribe();
  }
}
